import React from "react";
import { withRouter } from "react-router-dom";
import TotalOfficeStockBuiltWidget from "../../widgets/office/developer/TotalOfficeStockBuiltWidget";
import UnderConsrtuctionWidget from "../../widgets/office/developer/UnderConsrtuctionWidget";
import ProposedDevelopmentWidget from "../../widgets/office/developer/ProposedDevelopmentWidget";
import CurrentVacancyWidget from "../../widgets/office/developer/CurrentVacancyWidget";
import OccupiersWidgetDeveloper from "../../widgets/office/developer/OccupiersWidgetDeveloper";
import CurrentPassingRentWidgetDeveloper from "../../widgets/office/developer/CurrentPassingRentWidgetDeveloper";
import WaleWidgetDeveloper from "../../widgets/office/developer/WaleWidgetDeveloper";
import ReleasingSpreadWidgetDeveloper from "../../widgets/office/developer/ReleasingSpreadWidgetDeveloper";
import TopDevelopersBuiltStockDeveloperGraph from "../../widgets/office/developer/TopDevelopersBuiltStockDeveloperGraph";
import TopOccupiersDeveloper from "../../widgets/office/developer/TopOccupiersDeveloper";
import PassingRentMarketRent from "../../widgets/office/developer/PassingRentMarketRent";
import FutureRentEscalationsOccupiers from "../../widgets/office/developer/FutureRentEscalationsOccupiers";
import TopAssetsBrookfield from "../../widgets/office/developer/TopAssetsBrookfield";
import AreaLeasedTransactionSizeGraphOne from "../../widgets/office/developer/AreaLeasedTransactionSizeGraphOne";
import AreaLeasedTransactionSizeGraphTwo from "../../widgets/office/developer/AreaLeasedTransactionSizeGraphTwo";
import UpcomingSupplyDeveloper from "../../widgets/office/developer/UpcomingSupplyDeveloper";
import CitywisePresence from "../../widgets/office/developer/CitywisePresence";
import SectorBreakupAreaOccupied from "../../widgets/office/developer/SectorBreakupAreaOccupied";
import SectorWiseRent from "../../widgets/office/developer/SectorWiseRent";
import MajorRecentTransactionDeveloper from "../../widgets/office/developer/MajorRecentTransactionDeveloper";
import SectorBreakupAreaOccupied1 from "../../widgets/office/developer/SectorBreakupAreaOccupied1";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
class Developer3 extends React.Component {
  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
  }
  render() {
    return (
      <div className="container-fluid developer">
        <div class="newDashboard dashboardWidgetRow">
          <div class="newDashboardInner">
            <TotalOfficeStockBuiltWidget />
          </div>
          <div class="newDashboardInner">
            <UnderConsrtuctionWidget />
          </div>
          <div class="newDashboardInner">
            <CurrentPassingRentWidgetDeveloper />
          </div>
          <div class="newDashboardInner">
            <CurrentVacancyWidget />
          </div>
          <div class="newDashboardInner">
            <OccupiersWidgetDeveloper />
          </div>
          <div class="newDashboardInner">
            <ProposedDevelopmentWidget />
          </div>
          <div class="newDashboardInner">
            <WaleWidgetDeveloper />
          </div>
          <div class="newDashboardInner">
            <ReleasingSpreadWidgetDeveloper />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-8">
            <TopDevelopersBuiltStockDeveloperGraph />
          </div>
          <div className="col-lg-4">
            <TopOccupiersDeveloper />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <PassingRentMarketRent />
          </div>
          <div className="col-lg-6">
            <FutureRentEscalationsOccupiers />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <TopAssetsBrookfield />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <AreaLeasedTransactionSizeGraphOne />
          </div>
          <div className="col-lg-6">
            <AreaLeasedTransactionSizeGraphTwo />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <UpcomingSupplyDeveloper />
          </div>
          <div className="col-lg-6">
            <CitywisePresence />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <SectorBreakupAreaOccupied1 />
          </div>
          <div className="col-lg-6">
            <SectorWiseRent />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <MajorRecentTransactionDeveloper />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Developer3);
